import {call, put, select, takeLatest} from 'redux-saga/effects'
import {
  filterDataChange,
  getAll,
  getAllPaymentRequest,
  getTotalUsage,
  getTransactionStatistic,
  setError,
  setList,
  setPaymentRequestList,
  setTotalUsage,
  setTransactionStatistic,
  downloadPaymentDocument,
  setDownloadSuccess,
  setDownloadError,
} from './BillingRedux'
import {ResponseGenerator} from '../../../shared/models/ResponseGenerator'
import {
  getAllUserPaymentRequest,
  getAllUserTransaction,
  getTotalCreditUsage,
  getTransactionStatistics,
  downloadPaymentDocument as downloadPaymentDocumentAPI,
} from './BillingApi'
import {HTTP_CODE} from '../../../shared/constants'
import {BillingFilterModel} from '../models/BillingFilterModel'
import {PaymentRequestFilterModel} from '../models/PaymentRequestFilterModel'

export default function* saga() {
  yield takeLatest(
    getAllPaymentRequest.type,
    function* getAllPaymentRequestSaga(action: ReturnType<typeof getAllPaymentRequest>) {
      try {
        const filterData: PaymentRequestFilterModel = yield select(
          (state) => state.billing.paymentRequestFilter
        )
        const response: ResponseGenerator = yield call(getAllUserPaymentRequest, filterData)
        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        yield put(setPaymentRequestList(response.data))
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )
  yield takeLatest(
    getTotalUsage.type,
    function* getTotalCredit(action: ReturnType<typeof getTotalUsage>) {
      try {
        const response: ResponseGenerator = yield call(getTotalCreditUsage)
        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        yield put(setTotalUsage(response.data))
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )
  yield takeLatest(
    [getAll.type, filterDataChange.type],
    function* getAllBilling(action: ReturnType<typeof getAll>) {
      try {
        const filterData: BillingFilterModel = yield select((state) => state.billing.filter)
        const response: ResponseGenerator = yield call(getAllUserTransaction, filterData)
        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        yield put(setList(response.data))
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )
  yield takeLatest(
    getTransactionStatistic.type,
    function* getTransactionStatisticByDate(action: ReturnType<typeof getTransactionStatistic>) {
      try {
        const {startDate, endDate} = action.payload
        const response: ResponseGenerator = yield call(getTransactionStatistics, startDate, endDate)
        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message) //@TODO:check format
        }
        yield put(setTransactionStatistic(response.data))
      } catch (error: any) {
        yield put(setError(error.message))
      }
    }
  )
  yield takeLatest(
    downloadPaymentDocument.type,
    function* downloadPaymentDocumentSaga(action: ReturnType<typeof downloadPaymentDocument>) {
      try {
        const {userId, month, paymentTransactionId} = action.payload
        const response: ResponseGenerator = yield call(
          downloadPaymentDocumentAPI,
          userId,
          month,
          paymentTransactionId
        )
        if (response && response.status !== HTTP_CODE.SUCCESS) {
          throw new Error(response.data.message || 'Download failed')
        }
        yield put(setDownloadSuccess(response.data))
      } catch (error: any) {
        yield put(setDownloadError(error.message || 'Download failed'))
      }
    }
  )
}
